import UploadButton from '@/components/UploadButton/UploadButton';

export default function PageAddInference() {
  return <UploadButton />;
}
